import { ComponentStyleConfig } from '@chakra-ui/react';

export const Button: ComponentStyleConfig = {
  defaultProps: {
    variant: 'solid',
    size: 'md',
  },

  baseStyle: {
    fontFamily: 'body',
    fontWeight: 500,
    letterSpacing: '0',
    borderRadius: '999px',
    transition: 'all 0.2s ease',
  },

  sizes: {
    sm: { h: '36px', px: '14px', fontSize: '13px' },
    md: { h: '44px', px: '20px', fontSize: '14px' },
    lg: { h: '52px', px: '24px', fontSize: '15px' },
  },

  variants: {
    solid: {
      bg: 'text.primary',
      color: 'bg.canvas',
      _hover: {
        bg: 'accent.500',
        color: 'bg.canvas',
        _disabled: { bg: 'text.primary' },
      },
      _active: { bg: 'accent.500' },
    },

    ghost: {
      bg: 'transparent',
      color: 'text.primary',
      borderWidth: '1px',
      borderColor: 'line.strong',
      _hover: {
        bg: 'transparent',
        borderColor: 'accent.500',
        color: 'accent.500',
      },
      _active: {
        bg: 'transparent',
        borderColor: 'accent.500',
      },
    },

    quiet: {
      bg: 'transparent',
      color: 'text.muted',
      borderWidth: '1px',
      borderColor: 'line.subtle',
      _hover: {
        borderColor: 'accent.line',
        color: 'accent.500',
        bg: 'transparent',
      },
    },

    link: {
      bg: 'transparent',
      color: 'text.primary',
      px: 0,
      h: 'auto',
      _hover: {
        color: 'accent.500',
        textDecoration: 'none',
      },
    },
  },
};
